/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetCompositionsDetailEditsQueryResponse, WebAppGetCompositionsDetailEditsPathParams, WebAppGetCompositionsDetailEdits401, WebAppGetCompositionsDetailEdits403 } from "../models/WebAppGetCompositionsDetailEdits";

export function getWebAppGetCompositionsDetailEditsUrl(id: WebAppGetCompositionsDetailEditsPathParams["id"]) {
  const res = { method: 'GET', url: `/web-app/v1/compositions/${id}/edits` as const }
  return res
}

/**
 * @summary List video-editor edits for a composition
 * {@link /web-app/v1/compositions/:id/edits}
 */
export async function webAppGetCompositionsDetailEdits(id: WebAppGetCompositionsDetailEditsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetCompositionsDetailEditsQueryResponse, ResponseErrorConfig<WebAppGetCompositionsDetailEdits401 | WebAppGetCompositionsDetailEdits403>, unknown>({ method : "GET", url : getWebAppGetCompositionsDetailEditsUrl(id).url.toString(), ... requestConfig })
  return res.data
}